// UIComponents runs in some environments where window.navigator is undefined.
// See: https://git.hubteam.com/HubSpot/hubspot-book-builder/pull/88
const lowercasedUserAgent = window.navigator ? navigator.userAgent.toLowerCase() : '';
export const isIE11 = () => lowercasedUserAgent.includes('trident/');